// extracted by mini-css-extract-plugin
export default {"personCard":"PersonCard_personCard__i9tbD","personImage":"PersonCard_personImage__tWA5t","personName":"PersonCard_personName__KcPzz","personRole":"PersonCard_personRole__jNu1P"};